import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'

const stripePromise = loadStripe('pk_test_TYooMQauvdEDq54NiTphI7jx')
const options = {
    // passing the client secret obtained from the server
    clientSecret:
        'pi_3KqvSD2eZvKYlo2C1TV9Y4eo_secret_9CmDqDKX0cd7Dx17lvhwV6hvV',
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Elements stripe={stripePromise} options={options}>
                <App />
            </Elements>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
)

reportWebVitals()
